import { render, staticRenderFns } from "./BodyCell.vue?vue&type=template&id=0e60afa0"
import script from "./BodyCell.vue?vue&type=script&lang=js"
export * from "./BodyCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports